module.exports = __webpack_public_path__ + "static/media/Registration_Default.33f91ca1.gif";